import * as React from 'react';
import { Container, Grid2, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../../setup/Navbar';
import AutoComplete from '../../../BuiltInComponent/AutoComplete';
import ButtonNormal from '../../../BuiltInComponent/ButtonNormal';
import TextFields from '../../../BuiltInComponent/TextField';
import DatePickerSelf from '../../../BuiltInComponent/DatePricker';
import HeadingText from '../../../BuiltInComponent/HeadingTest';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { Table, TableHead, TableBody, TableCell, TableRow, TableContainer, Paper } from '@mui/material';
import { getSupplierList, } from '../../../features/setup/useableSlice';
import { createPOMaster, getPOData, createPODetail, getDraftPR, getPRDetails } from '../../../features/StockManagement/Purchases/poSlice';
import BasicAlerts from '../../../BuiltInComponent/Alert'

export default function AddPurchaseOrder() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useSelector(state => state.auth);
    const { suppliers } = useSelector(state => state.ru);
    const { returnpoID, draftPR } = useSelector(state => state.po);

    // const [poID, setPoID] = React.useState('');
    const [showAlert, setShowAlert] = React.useState(false);

    const [selectedPRID, setSelectedPRID] = React.useState(null);
    const [masterData, setMasterData] = React.useState({
        entDate: dayjs(new Date()).format('YYYY-MM-DD'),
        poID: returnpoID || '',
        userID: user.userID,
        PartyCode: '',
        remarks: '',
        poStatus: 'Pending',
        editStatus: false
    });

    const [detailList, setDetailList] = React.useState([]);

    React.useEffect(() => {
        dispatch(getDraftPR());
        dispatch(getSupplierList());
    }, [dispatch]);

    React.useEffect(() => {
        const passedpoID = location.state?.poID
        if (passedpoID) {
            dispatch(getPOData(passedpoID))
                .then(res => {
                    if (res.payload) {
                        if (res.payload.pm[0].poStatus === 'Pending') {
                            setMasterData(prev => ({
                                ...prev,
                                poID: res.payload.pm[0].poID,
                                entDate: res.payload.pm[0].entDate,
                                PartyCode: res.payload.pm[0].PartyCode,
                                remarks: res.payload.pm[0].remarks,
                                poStatus: res.payload.pm[0].poStatus,
                                editStatus: true
                            }))
                            if (detailList.length === 0) {
                                const fetchedItems = res.payload.pd.map(item => ({
                                    ...item,
                                    quantity: item.quantity || '',
                                    itemRate: item.itemRate || '',
                                    prID: item.prID
                                }));
                                setDetailList(fetchedItems);
                            }
                        } else {
                            setShowAlert(true)
                            setTimeout(() => {
                                navigate('/PurchaseOrder')
                            }, 3000);
                        }
                    } else {
                        setMasterData(prev => ({
                            ...prev,
                            poID: returnpoID
                        }))
                    }
                })
        }
    }, [location.state?.poID, navigate, dispatch, returnpoID, detailList.length]);

    const handleMasterChange = (data) => {
        const keys = Object.keys(data);
        setMasterData(prev => ({ ...prev, [keys[0]]: data[keys[0]] }));
    };

    const handlePRSelect = async (data) => {
        const prID = data.prID;
        const alreadyAdded = detailList.some(item => item.prID === prID);
        if (alreadyAdded) {
            alert(`PR #${prID} already added.`);
            return;
        }
        setSelectedPRID(prID);
        dispatch(getPRDetails(prID)).then(res => {
            if (res.payload) {
                const fetchedItems = res.payload.map(item => ({
                    ...item,
                    quantity: item.quantity || '',
                    itemRate: '',
                    prID: prID
                }));
                setDetailList(prev => [...prev, ...fetchedItems]);
            }
        });
    };

    const handleItemChange = (index, field, value) => {
        const updated = [...detailList];
        updated[index][field] = value;
        setDetailList(updated);
    };

    const saveMaster = () => {
        dispatch(createPOMaster(masterData)).then(res => {
            if (res.payload && res.payload.poID) {
                // setPoID(res.payload.poID);
                setMasterData(prev => ({ ...prev, poID: res.payload.poID }))
            }
        });
    };

    const saveDetails = () => {
        dispatch(createPODetail({ poID: masterData.poID, detailData: detailList, editStatus: masterData.editStatus }));
        // detailList.forEach(row => {
        //     dispatch(createPODetail({
        //         poID,
        //         itemCode: row.itemCode,
        //         itemRate: Math.round(row.itemRate, 2),
        //         quantity: parseFloat(row.quantity),
        //         prID: row.prID
        //     }));
        // });
        navigate('/PurchaseOrder');
    };

    return (
        <>
            <Navbar />
            <Container>
                {showAlert && (
                    <BasicAlerts
                        msg="This Purchase Request is not in Delivered status and cannot be edited."
                        getCloseCommand={setShowAlert}
                    />
                )}
                <Grid2 container spacing={2}>
                    <Grid2 size={4} sx={{ marginTop: 3 }} ></Grid2>
                    <Grid2 size={4} sx={{ marginTop: 3 }} ><HeadingText text={'Purchase Order'} /></Grid2>
                    <Grid2 size={4} sx={{ marginTop: 3 }} ></Grid2>
                    <Grid2 size={0.5}>
                        <KeyboardBackspaceIcon
                            sx={{
                                fontSize: 30, marginLeft: -1, color: 'white', cursor: 'pointer',
                                backgroundColor: '#1D4988', padding: 1, borderRadius: 50
                            }}
                            onClick={() => { navigate('/PurchaseOrder') }} />
                    </Grid2>
                    <Grid2 size={12}>
                        <Typography sx={{
                            marginLeft: -1,
                            color: 'grey', fontSize: 18, fontWeight: 'bolder'
                        }}>Master Data</Typography>
                    </Grid2>

                    <Grid2 size={2}>
                        <DatePickerSelf name="entDate" value={masterData.entDate} onChange={handleMasterChange} />
                    </Grid2>
                    <Grid2 size={3}>
                        <AutoComplete
                            label="Select Party"
                            listData={suppliers && suppliers}
                            value={suppliers.find(p => p.PartyCode === masterData.PartyCode)}
                            onChange={handleMasterChange}
                            disabledValue={masterData.poID ? true : false}
                        />
                    </Grid2>
                    <Grid2 size={5}>
                        <TextFields
                            label="Remarks"
                            name="remarks"
                            value={masterData.remarks}
                            onChange={handleMasterChange}
                            disStatus={false}
                        />
                    </Grid2>
                    <Grid2 size={2}>
                        <ButtonNormal text="Save PO Master" onClick={saveMaster} />
                    </Grid2>
                    {masterData.poID && (
                        <>
                            <Grid2 size={12}>
                                <Typography sx={{
                                    marginLeft: -1,
                                    color: 'grey', fontSize: 18, fontWeight: 'bolder'
                                }}>Detail Data</Typography>
                            </Grid2>
                            <Grid2 size={4}>
                                <AutoComplete
                                    label="Select Purchase Request"
                                    listData={draftPR && draftPR}
                                    value={draftPR.find(p => p.prID === selectedPRID)}
                                    onChange={(data) => handlePRSelect(data)}
                                />
                            </Grid2>
                            <Grid2 size={12}>
                                <EditablePOItemTable
                                    tableData={detailList && detailList}
                                    onFieldChange={handleItemChange}
                                />
                            </Grid2>

                            <Grid2 size={2}>
                                <ButtonNormal text="Save PO Details" onClick={saveDetails} />
                            </Grid2>
                        </>
                    )}
                </Grid2>
            </Container>
        </>
    );
}



// src/BuiltInComponent/EditablePOItemTable.jsx


function EditablePOItemTable({ tableData, onFieldChange }) {
    return (
        <TableContainer component={Paper}>
            <Table size="small">
                <TableHead sx={{ backgroundColor: '#f2f2f2' }}>
                    <TableRow>
                        <TableCell>Item Code</TableCell>
                        <TableCell>Description</TableCell>
                        <TableCell>Quantity</TableCell>
                        <TableCell>Rate</TableCell>
                        <TableCell>Amount</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {tableData.map((row, index) => {
                        const amount = (parseFloat(row.quantity || 0) * parseFloat(row.itemRate || 0)).toFixed(2);
                        return (
                            <TableRow key={index}>
                                <TableCell>{row.itemCode}</TableCell>
                                <TableCell>{row.itemDesc}</TableCell>

                                <TableCell>
                                    <TextFields
                                        name="quantity"
                                        value={row.quantity}
                                        onChange={(val) => onFieldChange(index, 'quantity', val.quantity)}
                                        disStatus={false}
                                    />
                                </TableCell>

                                <TableCell>
                                    <TextFields
                                        name="itemRate"
                                        value={row.itemRate}
                                        onChange={(val) => onFieldChange(index, 'itemRate', val.itemRate)}
                                        disStatus={false}
                                    />
                                </TableCell>

                                <TableCell>{amount}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
